import { InjectionToken, Provider } from '@angular/core'
import {
  UserContext,
  UserContextImpl,
  UserContextNotifier,
  UserService,
} from 'identity-services'

export const userContextToken = new InjectionToken<UserContext>(
  'UserContextToken',
)

export const userContextNotifierToken = new InjectionToken<UserContextNotifier>(
  'UserContextNotifierToken',
)

export const userContextImplProvider: Provider = {
  provide: UserContextImpl,
  useFactory: (userService: UserService): UserContextImpl => {
    return new UserContextImpl(userService)
  },
  deps: [UserService],
}

export const userContextProvider: Provider = {
  provide: userContextToken,
  useExisting: UserContextImpl,
}

export const userContextNotifierProvider: Provider = {
  provide: userContextNotifierToken,
  useExisting: UserContextImpl,
}
